// assets
import { DashboardOutlined } from '@ant-design/icons';
import GradingIcon from '@mui/icons-material/Grading';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import GTranslateOutlinedIcon from '@mui/icons-material/GTranslateOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import FlagCircleOutlinedIcon from '@mui/icons-material/FlagCircleOutlined';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
// icons
const icons = {
  DashboardOutlined,
  GradingIcon,
  LiveHelpOutlinedIcon,
  HandshakeOutlinedIcon,
  FmdGoodOutlinedIcon,
  PeopleAltOutlinedIcon,
  GTranslateOutlinedIcon,
  SettingsOutlinedIcon,
  FlagCircleOutlinedIcon,
  QueryStatsIcon,
  EditNoteOutlinedIcon,
  HelpCenterOutlinedIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  // title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'tableau de bord',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'checklist',
      title: 'Ma Liste de contrôle',
      type: 'item',
      url: '/checklist',
      icon: icons.GradingIcon,
      breadcrumbs: true
    },
    // {
    //   id: 'countries',
    //   title: 'Country',
    //   type: 'item',
    //   url: '/countries',
    //   icon: icons.FlagCircleOutlinedIcon,
    //   breadcrumbs: true
    // },
    {
      id: 'reports',
      title: 'Ma Rapports',
      type: 'item',
      url: '/reports',
      // url: '/test',
      icon: icons.HandshakeOutlinedIcon,
      breadcrumbs: true
    },
    // {
    //   id: 'notification',
    //   title: 'Notifications',
    //   type: 'item',
    //   url: '/notifications',
    //   icon: icons.FmdGoodOutlinedIcon,
    //   breadcrumbs: true
    // },
    // {
    //   id: 'language',
    //   title: 'Language',
    //   type: 'item',
    //   url: '/language',
    //   icon: icons.GTranslateOutlinedIcon,
    //   breadcrumbs: true
    // },
    {
      id: 'settings',
      title: 'Paramètres',
      type: 'item',
      url: '/settings',
      icon: icons.SettingsOutlinedIcon,
      breadcrumbs: true
    },
    {
      id: 'FAQ',
      title: 'FAQ',
      type: 'item',
      url: '/frequentquestions',
      icon: icons.QueryStatsIcon,
      breadcrumbs: true
    },
    {
      id: 'Feedback',
      title: 'Retour',
      type: 'item',
      url: '/Feedback',
      icon: icons.EditNoteOutlinedIcon,
      breadcrumbs: true
    },
    {
      id: 'Contact_IIF_Admin',
      title: "Contacter l'administrateur de l'IIF",
      type: 'item',
      url: '/contactiifadmin',
      icon: icons.HelpCenterOutlinedIcon,
      breadcrumbs: true
    },
    {
      id: 'User_Manual',
      title: "Manuel de l'utilisateur",
      type: 'item',
      url: 'https://isuzu-ds.s3.me-central-1.amazonaws.com/assets/help/Dealer+Portal.pdf',
      icon: icons.HelpCenterOutlinedIcon,
      breadcrumbs: true,
      target: '_blank'
    }
    // {
    //   id: 'Help',
    //   title: 'Aide',
    //   type: 'item',
    //   url: '/help',
    //   icon: icons.HelpCenterOutlinedIcon,
    //   breadcrumbs: true
    // }
  ]
};

export default dashboard;
